import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedKelas } from '../../features/waliKelasSlice';
import close from '../../assets/icons/close.svg';
import plus from '../../assets/icons/plus.svg';
import ModalKelas from './ModalKelas';

function KelasSelectWK() {
    const dispatch = useDispatch();
    const { selectedKelas } = useSelector((state) => state.waliKelas);
    const [modalActive, setModalActive] = useState(false);

    return (
        <div className='wrapper-container-jabatan'>
            {selectedKelas && (
                <div className='container-jabatan' style={{ width: '700px' }}>
                    <p>{selectedKelas.category}</p>
                    <img src={close} alt="" onClick={() => dispatch(clearSelectedKelas())} />
                </div>
            )}
            {!selectedKelas && (
                <div className='container-jabatan btn-plus' onClick={() => setModalActive(true)}>
                    <img src={plus} alt="" />
                </div>
            )}
            {modalActive && <ModalKelas onClose={() => setModalActive(false)} />}
        </div>
    );
}

export default KelasSelectWK;
